import { AiOutlineTwitter } from 'react-icons/ai'
import { AiFillGithub } from 'react-icons/ai'
import { AiFillLinkedin } from 'react-icons/ai'

export const links=[
    {id:1,link:'#',title:'Home'},
    {id:2,link:'#about',title:'About'},
    {id:3,link:'#services',title:'Services'},
    {id:4,link:'#portfolio',title:'Portfolio'},
    {id:5,link:'#contact',title:'Contact'}
]

export const socials = [
  {
    id: 1,
    link: "https://twitter.com/bashysureboi",
    icon: <AiOutlineTwitter />,
  },
  { id: 2, link: "https://github.com/bashytech007", icon: <AiFillGithub /> },
  {
    id: 3,
    link: "https://www.linkedin.com/in/bashir-aremu-880813aa/",
    icon: <AiFillLinkedin />,
  },
];

